import { marketsDir } from './routeUtils'
import staticPages from './getStaticPages';

const findTranslatedUrl = (currentUrl, targetLanguage, menuData) => {
    const validLangs = ['es', 'pt', 'en'];
    const segments = currentUrl.split('/');
    const actualLanguage = segments[1]
    if (segments.length <= 2 && validLangs.includes(segments[1] || '')) {
        return `/${targetLanguage}`;
    }

    const staticUrl = mapStaticByPosition(segments, actualLanguage, targetLanguage)
    if (staticUrl) {
        return staticUrl
    }

    const marketRegex = /^\/(es|pt|en)\/(?:mercados|markets)\/([^\/]+)$/;
    const m = marketRegex.exec(currentUrl);
    if (m?.length === 3) {
        const currentSlug = m[2];
        const dir = marketsDir(targetLanguage)
        console.log(`/${targetLanguage}/${dir}/${currentSlug}`);

        return `/${targetLanguage}/${dir}/${currentSlug}`
    }

    const currentMenu = menuData.find(item => item[targetLanguage]);
    if (!currentMenu) return `/${targetLanguage}`;

    let targetUrl = null;
    const findUrl = (nodes) => {
        for (const node of nodes) {
            if (node?.translations?.[actualLanguage] === currentUrl) {
                targetUrl = node.url || null;
                return;
            }

            if (node.children.length > 0) {
                findUrl(node.children);
                if (targetUrl) return;
            }
        }
    };

    findUrl(currentMenu[targetLanguage]);
    return (targetUrl && targetUrl !== '')
        ? targetUrl
        : `/${targetLanguage}`;
};

function mapStaticByPosition(
    segments,
    actualLanguage,
    targetLang
) {
    const pagesSrc = staticPages[actualLanguage]
    const pagesDst = staticPages[targetLang]
    if (!pagesSrc || !pagesDst) return null

    const slug = segments[2]
    if (!slug || !(slug in pagesSrc)) return null

    if (slug === 'faqs') {
        const srcFaqs = pagesSrc.faqs || {}
        const dstFaqs = pagesDst.faqs || {}
        const sub = segments[3]

        if (!sub) {
            return Object.keys(dstFaqs).length
                ? `/${targetLang}/faqs`
                : `/${targetLang}`
        }

        if (!(sub in srcFaqs)) {
            return null
        }

        if (srcFaqs[sub] === '') {
            return `/${targetLang}`
        }

        const srcKeys = Object.keys(srcFaqs)
        const idx = srcKeys.indexOf(sub)
        const dstKeys = Object.keys(dstFaqs)
        const subDst = dstKeys[idx]

        return subDst
            ? `/${targetLang}/faqs/${subDst}`
            : `/${targetLang}`
    }

    const val = pagesSrc[slug]
    if (val === '') {
        return `/${targetLang}`
    }

    const srcKeys = Object.keys(pagesSrc)
    const idx = srcKeys.indexOf(slug)
    const dstKeys = Object.keys(pagesDst)
    const slugDst = dstKeys[idx]

    return slugDst
        ? `/${targetLang}/${slugDst}`
        : `/${targetLang}`
}

export default findTranslatedUrl;